function popObject(obj: Record<string, any>): Record<string, any> {
    const key = Object.keys(obj).pop();

    if (key != null) {
        delete obj[key];
    }

    return obj;
}

// ----------------------------------------------------------------------------

export default popObject;
